import { ThemeNames, ThemeType, } from '../types.js';
const name = ThemeNames.Lions;
const displayName = 'Millwall';
const type = ThemeType.Club;
const socials = {
    facebookUrl: 'https://www.facebook.com/profile.php?id=61586107954371',
};
const siteConfig = {
    gamblingCommissionUrl: 'www.gambleaware.org',
};
// TODO: Move to CMS
const assets = {
    logo: '/assets/images/lions/logo.png',
    logoLight: '/assets/images/lions/logo.png',
    logoMobile: '/assets/images/lions/logo-mobile.svg',
    logoCard: '/assets/images/lions/logo-prize-dark.png',
    banner: '/assets/images/lions/banner.png',
    logoBanner: '/assets/images/lions/logo-sm.svg',
    postalIcon: '/assets/images/lions/post-lions.svg',
    loserImage: '/assets/images/lions/non-winner.webp',
    partners: [
        '/assets/images/partners/lions/errea.png',
        '/assets/images/partners/lions/fxd-capital.svg',
        '/assets/images/partners/lions/wiggett-group.svg',
        '/assets/images/partners/lions/errea.png',
        '/assets/images/partners/lions/fxd-capital.svg',
        '/assets/images/partners/lions/wiggett-group.svg',
        '/assets/images/partners/lions/errea.png',
        '/assets/images/partners/lions/fxd-capital.svg',
        '/assets/images/partners/lions/wiggett-group.svg',
    ],
    howToRedeem: [
        '/how-to-redeem/lions/redeem-step-1.png',
        '/how-to-redeem/lions/redeem-step-2.png',
        '/how-to-redeem/lions/redeem-step-3.png',
        '/how-to-redeem/lions/redeem-step-4.png',
    ],
    liveDrawWinners: '/assets/images/presenters/holly-cutout.png',
    comingSoon: '/assets/images/banners/coming-soon-horizontal.png',
    comingSoonLarge: '/assets/images/banners/coming-soon.png',
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#000F2C',
                'primary-light': '#E0EBFF',
                'primary-lighter': '#E0EBFF',
                secondary: '#000F2C',
                'secondary-dark': '#000F2C',
                'secondary-light': '#000F2C',
                tertiary: '#B88A44',
                'tertiary-light': '#FAF398',
                'tertiary-dark': '#B88A44',
                black: '#1E293B',
                'black-light': '#566989',
                teal: '#000F2C',
                'pastel-blue': '#000F2C',
            },
        },
    },
};
const designTokens = {
    // General
    generalColorFocus: '#0085e5',
    // AbstractButton
    buttonBorderWidth: '1px',
    buttonBorderRadius: '1000px',
    buttonPrimaryDefaultBackground: '#b88a44',
    buttonPrimaryDefaultForeground: '#082330',
    buttonPrimaryDefaultColorBorder: '#ffffff00',
    buttonPrimaryHoverBackground: '#e6bb65',
    buttonPrimaryHoverForeground: '#082330',
    buttonPrimaryHoverColorBorder: '#ffffff00',
    buttonPrimaryPressedBackground: '#7a582d',
    buttonPrimaryPressedForeground: '#082330',
    buttonPrimaryPressedColorBorder: '#ffffff00',
    buttonSecondaryDefaultBackground: '#000f2c',
    buttonSecondaryDefaultForeground: '#ffffff',
    buttonSecondaryDefaultColorBorder: '#ffffff00',
    buttonSecondaryHoverBackground: '#001a4a',
    buttonSecondaryHoverForeground: '#ffffff',
    buttonSecondaryHoverColorBorder: '#ffffff00',
    buttonSecondaryPressedBackground: '#000714',
    buttonSecondaryPressedForeground: '#ffffff',
    buttonSecondaryPressedColorBorder: '#ffffff00',
    buttonTertiaryDefaultBackground: '#ffffff',
    buttonTertiaryDefaultForeground: '#082330',
    buttonTertiaryDefaultColorBorder: '#b6c6cf',
    buttonTertiaryHoverBackground: '#ffffff',
    buttonTertiaryHoverForeground: '#082330',
    buttonTertiaryHoverColorBorder: '#b6c6cf',
    buttonTertiaryPressedBackground: '#e2eaed',
    buttonTertiaryPressedForeground: '#082330',
    buttonTertiaryPressedColorBorder: '#b6c6cf',
    // TextButton
    buttonTextFontFamily: 'Inter',
    buttonTextFontWeight: '700',
    buttonTextLineHeight: '1',
    buttonTextLgPaddingVertical: '12px',
    buttonTextLgPaddingHorizontal: '24px',
    buttonTextLgGap: '8px',
    buttonTextLgFontSize: '16px',
    buttonTextLgSizeIcon: '16px',
    buttonTextMdPaddingVertical: '8px',
    buttonTextMdPaddingHorizontal: '16px',
    buttonTextMdGap: '8px',
    buttonTextMdFontSize: '14px',
    buttonTextMdSizeIcon: '16px',
    buttonTextSmPaddingVertical: '6px',
    buttonTextSmPaddingHorizontal: '12px',
    buttonTextSmGap: '4px',
    buttonTextSmFontSize: '12px',
    buttonTextSmSizeIcon: '12px',
    // IconButton
    buttonIconXlPadding: '12px',
    buttonIconXlSizeIcon: '40px',
    buttonIconLgPadding: '8px',
    buttonIconLgSizeIcon: '24px',
    buttonIconMdPadding: '6px',
    buttonIconMdSizeIcon: '20px',
    buttonIconSmPadding: '4px',
    buttonIconSmSizeIcon: '16px',
    buttonIconTertiaryDefaultBackground: '#e2eaed',
    buttonIconTertiaryDefaultForeground: '#082330',
    buttonIconTertiaryDefaultColorBorder: '#ffffff00',
    buttonIconTertiaryHoverBackground: '#edf2f7',
    buttonIconTertiaryHoverForeground: '#082330',
    buttonIconTertiaryHoverColorBorder: '#ffffff00',
    buttonIconTertiaryPressedBackground: '#e2eaed',
    buttonIconTertiaryPressedForeground: '#082330',
    buttonIconTertiaryPressedColorBorder: '#ffffff00',
    // Checkbox
    checkboxSize: '24px',
    checkboxSizeTick: '16px',
    checkboxBorderRadius: '4px',
    checkboxBorderWidth: '1px',
    checkboxColorBorder: '#001a4a',
    checkboxDefaultBackground: '#ffffff',
    checkboxHoverBackground: '#edf2f7',
    checkboxPressedBackground: '#e2eaed',
    checkboxSelectedBackground: '#001a4a',
    checkboxSelectedForeground: '#ffffff',
    // Switch
    switchTrackPaddingHorizontal: '4px',
    switchTrackWidth: '52px',
    switchTrackHeight: '32px',
    switchTrackBorderWidth: '1px',
    switchTrackBorderRadius: '1000px',
    switchTrackBackground: '#e2eaed',
    switchTrackSelectedBackground: '#001a4a',
    switchHandleBorderRadius: '1000px',
    switchHandleSize: '24px',
    switchHandleDefaultBackground: '#082330',
    switchHandleHoverBackground: '#4c6475',
    switchHandlePressedBackground: '#01090c',
    switchHandleSelectedBackground: '#ffffff',
    switchHandleSelectedPressedBackground: '#e2eaed',
    // Tabs
    tabsItemForeground: '#082330',
    tabsItemSelector: '#001a4a',
    tabsItemSizeHighlight: '4px',
    tabsItemSizeIcon: '20px',
    tabsItemPaddingTop: '8px',
    tabsItemPaddingBottom: '12px',
    tabsItemPaddingHorizontal: '8px',
    tabsItemDefaultBackground: '#ffffff00',
    tabsItemHoverBackground: '#01090c0a',
    tabsItemPressedBackground: '#01090c14',
};
export default {
    assets,
    displayName,
    name,
    primitives,
    socials,
    type,
    designTokens,
    siteConfig,
};
